import { format, parseISO } from 'date-fns'

export function wasRequestUpdated(row) {
  if (!row || row.modifiedContactId == null) return false
  if (row.contactId == null) return false
  return row.modifiedContactId !== row.contactId
}

function formatRequestDate(date) {
  return date ? format(parseISO(date), 'MM/dd/yyyy') : ''
}

export function getRequestContactDisplay(row) {
  if (!row) return ''
  if (wasRequestUpdated(row)) {
    return row.updatedContactName || row.contactName || ''
  }
  return row.contactName || ''
}

export function getRequestDateDisplay(row) {
  if (!row) return ''
  if (wasRequestUpdated(row)) {
    return formatRequestDate(row.lastModified)
  }
  const created = row.created || row.insertDate
  return formatRequestDate(created)
}
